import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header d-flex justify-content-between align-itens-center col" }
const _hoisted_2 = { class: "float-start m-0 text-neutral_900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ds_button = _resolveComponent("ds-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.hasButton)
      ? (_openBlock(), _createBlock(_component_ds_button, {
          key: 0,
          hasButton: _ctx.hasButton,
          class: "float-end",
          type: "primary",
          text: _ctx.buttonText,
          leftIcon: "add",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push({ name: _ctx.buttonRoute }))
        }, null, 8, ["hasButton", "text"]))
      : _createCommentVNode("", true)
  ]))
}